const commonPaths = {
    production: [
        'userAppMng', 'userRegi', 'userAppMngDetail', 'userVehicleRegi', 'userVehicleModi', // 고객관리
        'rdiMng', // RDI 관리
        'orgMng', // 조직관리
        'cateMng', 'cateMngRegi', 'cateMngModi', // 부품/소모품판매 > 카테고리관리
        'banMng', 'banMngRegi', 'banMngModi', // 부품/소모품판매 > 대동 SHOP배너 관리
        'partsCons', 'partsConsRegi', 'partsConsModi', // 부품/소모품판매 > 부품/소모품 진열
        'remote', 'remoteDetail', 'remoteHistory', // 원격진단 > 원격진단
        'afterService', 'afterServiceDetail', 'afterServiceHistory', // 원격진단 > 애프터서비스
        'reProgram', 'reProgramDetail', 'reProgramHistory' // 원격진단 > 리프로그램
    ],
    productionStaff: [
        'userAppMng', 'userRegi', 'userAppMngDetail', 'userVehicleRegi', 'userVehicleModi', // 고객관리
        'rdiMng', // RDI 관리
        'orgMng', // 조직관리
        'cateMng', 'cateMngRegi', 'cateMngModi', // 부품/소모품판매 > 카테고리관리
        'banMng', 'banMngRegi', 'banMngModi', // 부품/소모품판매 > 대동 SHOP배너 관리
        'partsCons', 'partsConsRegi', 'partsConsModi', // 부품/소모품판매 > 부품/소모품 진열
        'remote', 'remoteDetail', 'remoteHistory', // 원격진단 > 원격진단
        'afterService', 'afterServiceDetail', 'afterServiceHistory', // 원격진단 > 애프터서비스
        'reProgram', 'reProgramDetail', 'reProgramHistory', // 원격진단 > 리프로그램
        //================================================
        'productionMngModi', 'vehicleSttsMngModi', 'modelMngModi', 'deviceMngModi'
    ],
    biz: [
        'modelMng', 'modelMngRegi', 'modelMngDetail', 'modelMngModi', // 모델관리
        'deviceMng', 'deviceMngDetail', 'deviceMngModi', // 단말기관리
        'rdiMng', // RDI 관리
        'orgMng', // 조직관리
        'remote', 'remoteDetail', 'remoteHistory', // 원격진단 > 원격진단
        'afterService', 'afterServiceDetail', 'afterServiceHistory', // 원격진단 > 애프터서비스
        'reProgram', 'reProgramDetail', 'reProgramHistory', // 원격진단 > 리프로그램
    ],
    bizStaff: [
        'modelMng', 'modelMngRegi', 'modelMngDetail', 'modelMngModi', // 모델관리
        'deviceMng', 'deviceMngDetail', 'deviceMngModi', // 단말기관리
        'rdiMng', // RDI 관리
        'orgMng', // 조직관리
        'remote', 'remoteDetail', 'remoteHistory', // 원격진단 > 원격진단
        'afterService', 'afterServiceDetail', 'afterServiceHistory', // 원격진단 > 애프터서비스
        'reProgram', 'reProgramDetail', 'reProgramHistory', // 원격진단 > 리프로그램
        'productionMngModi', 'vehicleSttsMngModi',
        'userRegi', 'userVehicleRegi', 'userVehicleModi'
    ],
    sales: [
        'modelMng', 'modelMngRegi', 'modelMngDetail', 'modelMngModi', // 모델관리
        // 'deviceMng', 'deviceMngDetail', 'deviceMngModi', // 단말기관리
        'rdiMng', // RDI 관리
        'orgMng', // 조직관리
        'cateMng', 'cateMngRegi', 'cateMngModi', // 부품/소모품판매 > 카테고리관리
        'banMng', 'banMngRegi', 'banMngModi', // 부품/소모품판매 > 대동 SHOP배너 관리
        'partsCons', 'partsConsRegi', 'partsConsModi', // 부품/소모품판매 > 부품/소모품 진열
        'remote', 'remoteDetail', 'remoteHistory', // 원격진단 > 원격진단
        'afterService', 'afterServiceDetail', 'afterServiceHistory', // 원격진단 > 애프터서비스
        'reProgram', 'reProgramDetail', 'reProgramHistory' // 원격진단 > 리프로그램
    ],
    salesStaff: [
        'modelMng', 'modelMngRegi', 'modelMngDetail', 'modelMngModi', // 모델관리
        // 'deviceMng', 'deviceMngDetail', 'deviceMngModi', // 단말기관리
        'rdiMng', // RDI 관리
        'orgMng', // 조직관리
        'cateMng', 'cateMngRegi', 'cateMngModi', // 부품/소모품판매 > 카테고리관리
        'banMng', 'banMngRegi', 'banMngModi', // 부품/소모품판매 > 대동 SHOP배너 관리
        'partsCons', 'partsConsRegi', 'partsConsModi', // 부품/소모품판매 > 부품/소모품 진열
        'remote', 'remoteDetail', 'remoteHistory', // 원격진단 > 원격진단
        'afterService', 'afterServiceDetail', 'afterServiceHistory', // 원격진단 > 애프터서비스
        'reProgram', 'reProgramDetail', 'reProgramHistory', // 원격진단 > 리프로그램
        'productionMngModi', 'vehicleSttsMngModi', 'userRegi', 'userVehicleRegi', 'userVehicleModi',
    ],
    business: [
        'modelMng', 'modelMngRegi', 'modelMngDetail', 'modelMngModi', // 모델관리
        'deviceMng', 'deviceMngDetail', 'deviceMngModi', // 단말기관리
        'rdiMng', // RDI 관리
        'orgMng', // 조직관리
        'noticeMng', 'noticeMngRegi', 'noticeMngDetail', // 공지사항 > 공지사항 관리
        'faqMng', 'faqMngRegi', 'faqMngDetail', // 공지사항 > FAQ 관리
        'postMng', 'postMngRegi', // 공지사항 > 게시판 관리
        'cateMng', 'cateMngRegi', 'cateMngModi', // 부품/소모품판매 > 카테고리관리
        'banMng', 'banMngRegi', 'banMngModi', // 부품/소모품판매 > 대동 SHOP배너 관리
        'partsCons', 'partsConsRegi', 'partsConsModi', // 부품/소모품판매 > 부품/소모품 진열
        'remote', 'remoteDetail', 'remoteHistory', // 원격진단 > 원격진단
        'afterService', 'afterServiceDetail', 'afterServiceHistory', // 원격진단 > 애프터서비스
        'reProgram', 'reProgramDetail', 'reProgramHistory' // 원격진단 > 리프로그램
    ],
    businessStaff: [
        'modelMng', 'modelMngRegi', 'modelMngDetail', 'modelMngModi', // 모델관리
        'deviceMng', 'deviceMngDetail', 'deviceMngModi', // 단말기관리
        'rdiMng', // RDI 관리
        'orgMng', // 조직관리
        'noticeMng', 'noticeMngRegi', 'noticeMngDetail', // 공지사항 > 공지사항 관리
        'faqMng', 'faqMngRegi', 'faqMngDetail', // 공지사항 > FAQ 관리
        'postMng', 'postMngRegi', // 공지사항 > 게시판 관리
        'cateMng', 'cateMngRegi', 'cateMngModi', // 부품/소모품판매 > 카테고리관리
        'banMng', 'banMngRegi', 'banMngModi', // 부품/소모품판매 > 대동 SHOP배너 관리
        'partsCons', 'partsConsRegi', 'partsConsModi', // 부품/소모품판매 > 부품/소모품 진열
        'remote', 'remoteDetail', 'remoteHistory', // 원격진단 > 원격진단
        'afterService', 'afterServiceDetail', 'afterServiceHistory', // 원격진단 > 애프터서비스
        'reProgram', 'reProgramDetail', 'reProgramHistory', // 원격진단 > 리프로그램
        'productionMngModi', 'vehicleSttsMngModi', 'userRegi', 'userVehicleRegi', 'userVehicleModi'
    ],
    region: [
        'modelMng', 'modelMngRegi', 'modelMngDetail', 'modelMngModi', // 모델관리
        'deviceMng', 'deviceMngDetail', 'deviceMngModi', // 단말기관리
        'rdiMng', // RDI 관리
        'orgMng', // 조직관리
        'noticeMng', 'noticeMngRegi', 'noticeMngDetail', // 공지사항 > 공지사항 관리
        'faqMng', 'faqMngRegi', 'faqMngDetail', // 공지사항 > FAQ 관리
        'postMng', 'postMngRegi', // 공지사항 > 게시판 관리
        'cateMng', 'cateMngRegi', 'cateMngModi', // 부품/소모품판매 > 카테고리관리
        'banMng', 'banMngRegi', 'banMngModi', // 부품/소모품판매 > 대동 SHOP배너 관리
        'partsCons', 'partsConsRegi', 'partsConsModi', // 부품/소모품판매 > 부품/소모품 진열
        'remote', 'remoteDetail', 'remoteHistory', // 원격진단 > 원격진단
        'afterService', 'afterServiceDetail', 'afterServiceHistory', // 원격진단 > 애프터서비스
        'reProgram', 'reProgramDetail', 'reProgramHistory' // 원격진단 > 리프로그램
    ],
    regionStaff: [
        'modelMng', 'modelMngRegi', 'modelMngDetail', 'modelMngModi', // 모델관리
        'deviceMng', 'deviceMngDetail', 'deviceMngModi', // 단말기관리
        'rdiMng', // RDI 관리
        'orgMng', // 조직관리
        'noticeMng', 'noticeMngRegi', 'noticeMngDetail', // 공지사항 > 공지사항 관리
        'faqMng', 'faqMngRegi', 'faqMngDetail', // 공지사항 > FAQ 관리
        'postMng', 'postMngRegi', // 공지사항 > 게시판 관리
        'cateMng', 'cateMngRegi', 'cateMngModi', // 부품/소모품판매 > 카테고리관리
        'banMng', 'banMngRegi', 'banMngModi', // 부품/소모품판매 > 대동 SHOP배너 관리
        'partsCons', 'partsConsRegi', 'partsConsModi', // 부품/소모품판매 > 부품/소모품 진열
        'remote', 'remoteDetail', 'remoteHistory', // 원격진단 > 원격진단
        'afterService', 'afterServiceDetail', 'afterServiceHistory', // 원격진단 > 애프터서비스
        'reProgram', 'reProgramDetail', 'reProgramHistory', // 원격진단 > 리프로그램
        'productionMngModi', 'vehicleSttsMngModi', 'userRegi', 'userVehicleRegi', 'userVehicleModi'
    ],
    dealership: [
        'modelMng', 'modelMngRegi', 'modelMngDetail', 'modelMngModi', // 모델관리
        'deviceMng', 'deviceMngDetail', 'deviceMngModi', // 단말기관리
        'rdiMng', // RDI 관리
        'orgMng', // 조직관리
        'noticeMng', 'noticeMngRegi', 'noticeMngDetail', // 공지사항 > 공지사항 관리
        'faqMng', 'faqMngRegi', 'faqMngDetail', // 공지사항 > FAQ 관리
        'postMng', 'postMngRegi', // 공지사항 > 게시판 관리
        'cateMng', 'cateMngRegi', 'cateMngModi', // 부품/소모품판매 > 카테고리관리
        'banMng', 'banMngRegi', 'banMngModi', // 부품/소모품판매 > 대동 SHOP배너 관리
        'partsCons', 'partsConsRegi', 'partsConsModi', // 부품/소모품판매 > 부품/소모품 진열
        'remote', 'remoteDetail', 'remoteHistory', // 원격진단 > 원격진단
        'afterService', 'afterServiceDetail', 'afterServiceHistory', // 원격진단 > 애프터서비스
        'reProgram', 'reProgramDetail', 'reProgramHistory' // 원격진단 > 리프로그램
    ],
    dealershipStaff: [
        'modelMng', 'modelMngRegi', 'modelMngDetail', 'modelMngModi', // 모델관리
        'deviceMng', 'deviceMngDetail', 'deviceMngModi', // 단말기관리
        'rdiMng', // RDI 관리
        'orgMng', // 조직관리
        'noticeMng', 'noticeMngRegi', 'noticeMngDetail', // 공지사항 > 공지사항 관리
        'faqMng', 'faqMngRegi', 'faqMngDetail', // 공지사항 > FAQ 관리
        'postMng', 'postMngRegi', // 공지사항 > 게시판 관리
        'cateMng', 'cateMngRegi', 'cateMngModi', // 부품/소모품판매 > 카테고리관리
        'banMng', 'banMngRegi', 'banMngModi', // 부품/소모품판매 > 대동 SHOP배너 관리
        'partsCons', 'partsConsRegi', 'partsConsModi', // 부품/소모품판매 > 부품/소모품 진열
        'remote', 'remoteDetail', 'remoteHistory', // 원격진단 > 원격진단
        'afterService', 'afterServiceDetail', 'afterServiceHistory', // 원격진단 > 애프터서비스
        'reProgram', 'reProgramDetail', 'reProgramHistory', // 원격진단 > 리프로그램
        'productionMngModi', 'vehicleSttsMngModi', 'userRegi', 'userVehicleRegi', 'userVehicleModi'
    ],
    readyOnly:[
        'productionMngModi', 'vehicleSttsMngModi', 'modelMngModi',
        'deviceMngModi', 'userRegi', 'userVehicleRegi', 'userVehicleModi',
        'noticeMngRegi', 'faqMngRegi', 'postMngRegi', 'cateMngRegi', 'cateMngModi', 
        'banMngRegi', 'banMngModi', 'partsConsRegi', 'partsConsModi'
    ],
};

export default commonPaths;